import React from 'react';
import PaymentsBrowser from '@/components/shared/PaymentsBrowser';

/** Support-agent view: read-only. No refund button (only admins can refund). */
export default function SupportPayments() {
  return <PaymentsBrowser endpoint="/support/payments" canRefund={false} testIdPrefix="support-payments" />;
}
